import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';

export type TourRegisterEmits = {};
export type TourRegisterProps = {};

export default class TourRegisterSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = {};

	constructor (
		private props: TourRegisterProps,
		private emits: TourRegisterEmits,
	) {
		super();
	}

}
